export default require("./node_modules/vue-clipboard3/dist/index.js");